import { render, staticRenderFns } from "./c-date-interval-field.vue?vue&type=template&id=fbf3ab52&scoped=true&"
import script from "./c-date-interval-field.vue?vue&type=script&lang=js&"
export * from "./c-date-interval-field.vue?vue&type=script&lang=js&"
import style0 from "./c-date-interval-field.vue?vue&type=style&index=0&id=fbf3ab52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf3ab52",
  null
  
)

export default component.exports